/**
 * Forma de visualização da lista de documentos da ordem de serviço. Fica no
 * usuário (`user.documentsView`) para a web e o app abrirem na mesma visão.
 */
export enum DocumentsViewEnum {
    /** Grade de cards compactos, na ordem da API. */
    CARDS = 'cards',
    /** Agrupado por mês da última edição, com cabeçalho recolhível por mês. */
    MONTH = 'month',
}
